<template>
  <el-menu
    :default-active="defaultActive"
    :router="true"
    class="el-menu-vertical-demo"
  >
    <div v-for="item in filteredMenuList" :key="item.path">
      <el-submenu v-if="item.childrenFiltered.length" :index="item.path">
        <template slot="title">
          <i
            class="icon"
            v-if="item.icon"
            :style="{ backgroundImage: `url(${item.icon})` }"
          ></i>
          <i
            class="icon active"
            v-if="item.icon"
            :style="{ backgroundImage: `url(${item.activeIcon})` }"
          ></i>
          <span>{{ item.title }}</span>
        </template>

        <el-menu-item
          v-for="child in item.childrenFiltered"
          :key="child.path"
          :index="child.path"
        >
          <i
            class="icon"
            v-if="item.icon"
            :style="{ backgroundImage: `url(${item.icon})` }"
          ></i>
          <i
            class="icon active"
            v-if="item.icon"
            :style="{ backgroundImage: `url(${item.activeIcon})` }"
          ></i>
          <span>{{ child.title }}</span>
        </el-menu-item>
      </el-submenu>

      <el-menu-item v-else :index="item.path">
        <i
          class="icon"
          v-if="item.icon"
          :style="{ backgroundImage: `url(${item.icon})` }"
        ></i>
        <i
          class="icon active"
          v-if="item.icon"
          :style="{ backgroundImage: `url(${item.activeIcon})` }"
        ></i>
        <span>{{ item.title }}</span>
      </el-menu-item>
    </div>
  </el-menu>
</template>

<script>
export default {
  name: "MenuSlider",
  props: {
    menuList: {
      type: Array,
      required: true,
    },
    defaultActive: {
      type: String,
      default: "",
    },
  },
  computed: {
    filteredMenuList() {
      const isOpenStore = localStorage.getItem("isOpenStore");
      let storeList = localStorage.getItem("storeList");
      let isTongji = true;
      if (storeList) {
        storeList = JSON.parse(storeList);
        isTongji = storeList.length > 1 ? false : true;
      }

      return this.menuList
        .filter((item) => {
          if (isOpenStore == "yes") {
            if (item.name == "orderQuery") {
              return isTongji;
            }
            return true;
          } else {
            return !item.isOpenStore;
          }
        })
        .map((item) => {
          return {
            ...item,
            childrenFiltered: (item.children || []).filter(
              (child) => !child.hidden
            ),
          };
        });
    },
  },
};
</script>

<style scoped lang="less">
/* 根据需要自定义样式 */
.icon {
  width: 22px;
  height: 22px;
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  display: inline-block;
  margin-right: 20px;
}
.el-menu-vertical-demo {
  border-right: none;
  background-color: transparent !important;
}

::v-deep .el-menu-item {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  color: var(--text-color1);
  border: none;

  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%; /* 24px */
  letter-spacing: 0.2px;
  &:hover {
    background: transparent;
  }
  .active {
    display: none;
  }
  &.is-active {
    background: #0038ff;
    color: #ffffff;
    .icon {
      display: none;
    }
    .active {
      display: inline-block;
    }
  }
}
</style>
